module.exports = __webpack_public_path__ + "static/img/car.a8080fb2.png";